import { useEffect, useState } from 'react';
import { Product } from '../../clients/quipli-service/product/product';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { useTaxApiV1 } from '../../clients/quipli-service/tax/tax-api-v1';
import { TaxCategory } from '../../clients/quipli-service/tax/tax';
import { toast } from '../../util/toasts';
import { OrderType } from '../../clients/quipli-service/order/order';
import { Typography } from '../../components/typography/typography';
import { Spinner } from '../../components/spinner/spinner';
import { ItemTaxCategoryInput } from './item-tax-category-input';
import { ItemType } from '../../clients/quipli-service/accounting/accounting';

export const ProductTaxCategoryInput = ({ productId }: { productId: number }) => {
  const [product, setProduct] = useState<Product>();
  const [splitSaleRental, setSplitSaleRental] = useState<boolean>();
  const [taxCategories, setTaxCategories] = useState<TaxCategory[] | undefined>();
  const { getProduct } = useAPI();
  const { searchTaxCategories, getTaxCategoryForItem } = useTaxApiV1();

  async function init() {
    try {
      const categories = await searchTaxCategories({});
      setTaxCategories(categories);
    } catch (e) {
      toast('Unable to fetch tax categories', 'error');
    }
    try {
      const [product, rentalTaxCategory, saleTaxCategory] = await Promise.all([
        getProduct(productId),
        getTaxCategoryForItem({
          itemType: ItemType.Product,
          itemId: productId.toString(),
          transactionType: OrderType.Rental,
        }),
        getTaxCategoryForItem({
          itemType: ItemType.Product,
          itemId: productId.toString(),
          transactionType: OrderType.Sale,
        }),
      ]);
      setSplitSaleRental(rentalTaxCategory?.taxCategoryId !== saleTaxCategory?.taxCategoryId);
      setProduct(product);
    } catch (e) {
      toast(`Unable to fetch tax categories ${e}`, 'error');
    }
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="item-tax-categories container-v2">
      {taxCategories && product ? (
        <div className="flex flex-column">
          {splitSaleRental ? (
            <>
              {product.allowRent && (
                <ItemTaxCategoryInput
                  itemType={ItemType.Product}
                  itemId={productId.toString()}
                  transactionType={OrderType.Rental}
                  taxCategories={taxCategories}
                  label="Rental Tax Categories"
                />
              )}
              {product.allowSale && (
                <ItemTaxCategoryInput
                  itemType={ItemType.Product}
                  itemId={productId.toString()}
                  transactionType={OrderType.Sale}
                  taxCategories={taxCategories}
                  label="Sale Tax Categories"
                />
              )}
            </>
          ) : (
            <>
              <ItemTaxCategoryInput
                itemType={ItemType.Product}
                itemId={productId.toString()}
                taxCategories={taxCategories}
              />
              <Typography type={'text-xs'}>
                <a onClick={() => setSplitSaleRental(!splitSaleRental)}>Split Sale/Rental</a>
              </Typography>
            </>
          )}
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
